// extracted by mini-css-extract-plugin
export default {"icon":"aUbh6","content":"wiFHS","heading":"eqVvL","headingIcon":"uu7lj","tooltip":"BEeco"};